import { Props as ApexChartOptions } from "react-apexcharts";

type PieChartOptions = ApexChartOptions & {
  colors?: string[];
  labels?: string[];
  series?: unknown[];
};

const sanitizePieChartOptions = (
  options: PieChartOptions
): PieChartOptions & { series: number[] } => {
  const rawSeries = Array.isArray(options?.series) ? options.series : [];

  const normalizedSeries = rawSeries
    .map((value, index) => {
      const parsedValue =
        typeof value === "number"
          ? value
          : typeof value === "string" && value.trim() !== ""
            ? Number(value)
            : Number.NaN;

      return {
        index,
        value: parsedValue,
      };
    })
    .filter((entry): entry is { index: number; value: number } =>
      Number.isFinite(entry.value)
    );

  const validIndexes = normalizedSeries.map((entry) => entry.index);

  const labels = Array.isArray(options?.labels)
    ? validIndexes
        .map((index) => options.labels?.[index])
        .filter((label): label is string => typeof label === "string")
    : [];

  const colors = Array.isArray(options?.colors)
    ? validIndexes
        .map((index) => options.colors?.[index])
        .filter((color): color is string => typeof color === "string")
    : undefined;

  return {
    ...options,
    labels,
    ...(colors ? { colors } : {}),
    series: normalizedSeries.map((entry) => entry.value),
  };
};

export default sanitizePieChartOptions;
